import HttpClient from './utils/HttpClient';

class AppointmentCategoriesService {
  constructor(baseUrl) {
    
    this.baseUrl = baseUrl;

    this.httpClient = new HttpClient(this.baseUrl)
  }

  async listAppointmentCategories() {
    const urlPath = '/appointmentcategories/get-all';

    return this.httpClient.get(urlPath);
  }
}

export default AppointmentCategoriesService;